import React from "react";
import { Box, Text, ImageView, Flex, Icon, Asset, utils } from "@thenounproject/lingo-core";
import { MetaWrapper } from "./DefaultMeta";

const { getTextColor, getColorBasedOnLightness } = utils;

type Props = {
  asset: Asset;
  background?: string;
};

const LinkMeta = ({ asset, background }: Props) => {
  const { fld, favicon } = asset.meta.content;
  const primaryTextColor = getTextColor(background || "#ffffff");
  const secondaryTextColor = getColorBasedOnLightness(
    background || "#ffffff",
    "grayDarkest",
    "grayLightest"
  );
  return (
    <MetaWrapper key="meta-element">
      <Box>
        <Text font="ui.regular" color={primaryTextColor}>
          {asset?.name || asset?.meta?.content?.url || "Unnamed asset"}
        </Text>
      </Box>
      <Flex>
        {favicon ? (
          <ImageView src={favicon} height="16" width="16" mr="4px" />
        ) : (
          <Icon size="16" iconId="globe" mr="4px" fill="grayDarker" />
        )}
        <Box>
          <Text font="ui.small" color={secondaryTextColor}>
            URL{fld ? ` • ${fld}` : ""}
          </Text>
        </Box>
      </Flex>
    </MetaWrapper>
  );
};

export default LinkMeta;
